var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM13.19 5H10.9775C10.7375 4.0625 10.3925 3.1625 9.9425 2.33C11.3225 2.8025 12.47 3.7625 13.19 5ZM8 2.03C8.6225 2.93 9.11 3.9275 9.4325 5H6.5675C6.89 3.9275 7.3775 2.93 8 2.03ZM2.195 9.5C2.075 9.02 2 8.5175 2 8C2 7.4825 2.075 6.98 2.195 6.5H4.73C4.67 6.995 4.625 7.49 4.625 8C4.625 8.51 4.67 9.005 4.73 9.5H2.195ZM2.81 11H5.0225C5.2625 11.9375 5.6075 12.8375 6.0575 13.67C4.6775 13.1975 3.53 12.245 2.81 11ZM5.0225 5H2.81C3.53 3.755 4.6775 2.8025 6.0575 2.33C5.6075 3.1625 5.2625 4.0625 5.0225 5ZM8 13.97C7.3775 13.07 6.89 12.0725 6.5675 11H9.4325C9.11 12.0725 8.6225 13.07 8 13.97ZM9.755 9.5H6.245C6.1775 9.005 6.125 8.51 6.125 8C6.125 7.49 6.1775 6.9875 6.245 6.5H9.755C9.8225 6.9875 9.875 7.49 9.875 8C9.875 8.51 9.8225 9.005 9.755 9.5ZM9.9425 13.67C10.3925 12.8375 10.7375 11.9375 10.9775 11H13.19C12.47 12.2375 11.3225 13.1975 9.9425 13.67ZM11.27 9.5C11.33 9.005 11.375 8.51 11.375 8C11.375 7.49 11.33 6.995 11.27 6.5H13.805C13.925 6.98 14 7.4825 14 8C14 8.5175 13.925 9.02 13.805 9.5H11.27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSymbol);
export default __webpack_public_path__ + "static/media/account-symbol.0cf9a81468099369d0eb153900698009.svg";
export { ForwardRef as ReactComponent };